import { Chip } from "@mui/material";

// Tag pill for the glass cards. The animated gradient gets very light on its
// blue/mint stops, so a light-glass chip (white text on ~12% white) drops below
// readable contrast, which is what made these tags look invisible. A near-opaque
// dark "ink" fill with bold white text keeps contrast well above WCAG AA (~8:1+)
// on every gradient stop while staying inside the glass language.
const TagChip = ({ sx, ...props }) => (
  <Chip
    size="small"
    sx={{
      backgroundColor: "rgba(8, 18, 34, 0.72)",
      color: "#fff",
      fontFamily: "Roboto, sans-serif",
      fontSize: "11px",
      fontWeight: 600,
      letterSpacing: "0.2px",
      height: "24px",
      // No backdrop blur: the fill is 72% opaque ink, so a blur of the gradient
      // behind it is invisible - but it still cost a GPU pass per chip, per frame.
      border: "1px solid rgba(255, 255, 255, 0.22)",
      "& .MuiChip-label": { px: 1.25 },
      ...sx,
    }}
    {...props}
  />
);

export default TagChip;
